import type { TAuthUser } from '@cascade/core/auth';
import type { TIdentity } from '@cascade/react-dom/observability';

export const toIdentity = (
  user?: TAuthUser,
  projectId?: string,
): TIdentity | undefined => {
  if (!user) {
    return undefined;
  }

  return {
    userId: user.id,
    traits: {
      email: user.email,
      ...(projectId ? { projectId } : {}),
    },
  };
};
